
const AudienceHome = () => import("../views/pages/tianbao/audience/audience-home.vue");
const BasicMobile = () => import("../views/pages/tianbao/audience/basic-mobile/index.vue"); //移动端申报
const success = () => import("../views/pages/tianbao/audience/home-mobile-success/index.vue"); // 移动端申报 
const BasicMobileEn = () => import("../views/pages/tianbao/audienceEn/basic-mobile/index.vue"); //移动端申报
const successEn = () => import("../views/pages/tianbao/audienceEn/home-mobile-success/index.vue"); // 移动端申报 

const tianbaoRouter = [
    {
        path: "/basic/mobile",
        name: "BasicMobile",
        component: BasicMobile,
        meta: { requireAuth: false },
    },
    {
        path: "/basic/success",
        name: "/basic/success",
        component: success,
        meta: { requireAuth: false },
    },
    {
        path: "/basic/mobileEn",
        name: "BasicMobileEn",
        component: BasicMobileEn,
        meta: { requireAuth: false },
    },
    {
        path: "/basic/successEn",
        name: "/basic/successEn",
        component: successEn,
        meta: { requireAuth: false },
    },
    {
        // 参展申请 - 登录
        path: "/join-login",
        name: "/join-login",
        component: resolve => require(["@views/pages/tianbao/audience/joinEx/subpages/login"], resolve),
        meta: { requireAuth: false }
    },
    {
        path: "/fill",
        name: "fill",
        component: AudienceHome,
        redirect: '/fill/join/basic',
        meta: { requireAuth: false },
        children: [
            {
                // 参展申请
                path: "join",
                name: "join",
                component: resolve => require(["@views/pages/tianbao/audience/joinEx/index"], resolve),
                redirect: "/fill/join/basic",
                meta: { requireAuth: false },
                children: [
                    {
                        // 基本信息
                        path: "basic",
                        name: "basic",
                        component: resolve => require(["@views/pages/tianbao/audience/joinEx/subpages/basic"], resolve),
                        meta: { requireAuth: false }
                    },
                    {
                        // 选择入口
                        path: "entrance",
                        name: "entrance",
                        component: resolve => require(["@views/pages/tianbao/audience/joinEx/subpages/entrance"], resolve), meta: { requireAuth: false }
                    },
                    {
                        // 选择订单
                        path: "order",
                        name: "order",
                        component: resolve => require(["@views/pages/tianbao/audience/joinEx/subpages/order"], resolve), meta: { requireAuth: false }
                    },
                    {
                        // 会刊信息
                        path: "catalogue",
                        name: "catalogue",
                        component: resolve => require(["@views/pages/tianbao/audience/joinEx/subpages/catalogue"], resolve), meta: { requireAuth: false }
                    },
                    {
                        // 报名表
                        path: "application",
                        name: "application",
                        component: resolve => require(["@views/pages/tianbao/audience/joinEx/subpages/application"], resolve), meta: { requireAuth: false }
                    },
                    {
                        // 完成
                        path: "finish",
                        name: "finish",
                        component: resolve => require(["@views/pages/tianbao/audience/joinEx/subpages/finish"], resolve), meta: { requireAuth: false }
                    },
                ],
            },
        ],
    },
]


export {
    tianbaoRouter,
}; 
